import React, { forwardRef, memo } from 'react';
import { SvgIcon } from '@material-ui/core';

export const IconSearch = memo(
  forwardRef((props, ref) => (
    <SvgIcon
      {...props}
      ref={ref}
      viewBox="0 0 20 20"
      data-fill-none
    >
      <path
        d="M17.995 16.754L14.7488 13.534C16.0088 11.9628 16.6191 9.96861 16.454 7.96136C16.2889 5.95411 15.361 4.08641 13.8611 2.74229C12.3612 1.39816 10.4033 0.679793 8.39006 0.734883C6.37679 0.789974 4.46114 1.61434 3.03701 3.03847C1.61287 4.4626 0.788509 6.37825 0.733418 8.39153C0.678328 10.4048 1.3967 12.3627 2.74082 13.8626C4.08494 15.3624 5.95265 16.2903 7.95989 16.4554C9.96714 16.6205 11.9614 16.0103 13.5325 14.7502L16.7525 17.9702C16.8338 18.0522 16.9306 18.1173 17.0373 18.1618C17.1439 18.2062 17.2582 18.229 17.3738 18.229C17.4893 18.229 17.6036 18.2062 17.7103 18.1618C17.8169 18.1173 17.9137 18.0522 17.995 17.9702C18.1527 17.8071 18.2409 17.589 18.2409 17.3621C18.2409 17.1352 18.1527 16.9171 17.995 16.754V16.754ZM8.62376 14.7502C7.41235 14.7502 6.22814 14.391 5.22089 13.718C4.21364 13.0449 3.42858 12.0884 2.96499 10.9692C2.50141 9.84996 2.38011 8.61843 2.61645 7.43029C2.85278 6.24216 3.43613 5.15079 4.29273 4.29419C5.14932 3.4376 6.24069 2.85425 7.42883 2.61791C8.61696 2.38158 9.8485 2.50287 10.9677 2.96646C12.0869 3.43005 13.0435 4.2151 13.7165 5.22235C14.3895 6.2296 14.7488 7.41381 14.7488 8.62522C14.7488 10.2497 14.1034 11.8076 12.9548 12.9562C11.8061 14.1049 10.2482 14.7502 8.62376 14.7502V14.7502Z"
        fill="currentColor"
      />
    </SvgIcon>
  ))
);
